
import type { SVGProps } from 'react';
const SvgHome = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#home_svg__a)">
      <path
        fill="#263E6A"
        d="M19.033 21.724h-8.087a.56.56 0 0 1-.558-.56V15.19H7.486v5.974c0 .309-.25.56-.557.56H5.186a.56.56 0 0 1-.557-.56v-8.6H1.463c-.207 0-.37-.103-.436-.274-.065-.171-.012-.356.143-.495l10.823-9.65a.576.576 0 0 1 .78.014l10.068 9.64c.149.141.197.327.129.495-.068.17-.23.27-.435.27H19.59v8.6c0 .309-.25.56-.557.56m-7.91-.736h7.732v-8.6c0-.309.25-.56.558-.56h2.396l-9.438-9.035-10.134 9.036h2.57c.307 0 .557.25.557.559v8.6H6.75v-5.974c0-.308.25-.56.557-.56h3.258a.56.56 0 0 1 .557.56zm1.14-18.298h.001"
      />
    </g>
    <defs>
      <clipPath id="home_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHome;
